'use strict';
const mmWidgets = require('./mm-widgets'),
	placeCaretAtEnd = require('@mindmup/mapjs/src/browser/place-caret-at-end');

require('./text-only-paste-widget');
require('./mm-scroll-into-view');


mmWidgets.fn.noteWidget = function (writerModel, initialNote, shouldEdit, noteFormatter) {
	return mmWidgets.each(this, function () {
		let note = initialNote,
			shouldSave = false,
			timeoutId = false;
		const KEY_ESC = 27,
			element = this,
			viewer = element.find('[data-mm-role=viewer]').textOnlyPasteWidget(),
			title = element.find('[data-mm-role=title]'),
			exitEditor = function (resetContent) {
				viewer.removeAttr('contenteditable');
				if (resetContent) {
					viewer.html(noteFormatter(note.text));
				}
			},
			exitAndSave = function () {
				const value = viewer.text().trim(),
					currentHtml = viewer.html();
				if (!element.data('moving')) {
					if (shouldSave && (note.text !== value && currentHtml !== noteFormatter(note.text))) {
						writerModel.setText(note.nodeId, value);
					} else if (note.isTemp) {
						writerModel.setText(note.nodeId, '');
					} else {
						viewer.html(noteFormatter(note.text));
					}
					exitEditor();
				}
			},
			dropNote = function (droppedId) {
				if (droppedId == note.nodeId) { //eslint-disable-line eqeqeq
					//element.remove();
					listeners('remove'); //eslint-disable-line no-use-before-define
				}
			},
			changeNote = function (newNote) {
				if (newNote.nodeId == note.nodeId) { //eslint-disable-line eqeqeq
					note = newNote;
					viewer.html(noteFormatter(newNote.text));
					title.text(newNote.title);
				}
			},
			foldNote = function (nodeId) {
				if (nodeId == note.nodeId && !viewer.attr('contenteditable')) { //eslint-disable-line eqeqeq
					element.toggleClass('folded');
				}
			},
			startEditing = function (noteToEdit) {
				if (noteToEdit.nodeId != note.nodeId) { //eslint-disable-line eqeqeq
					return;
				}
				shouldSave = true;
				element.removeClass('folded');
				note = noteToEdit;

				viewer.attr('contenteditable', 'true').text(noteToEdit.text);
				viewer.focus();
				placeCaretAtEnd(viewer.domElements[0]);
				element.mmScrollIntoView();
			},
			listeners = function (action) {
				writerModel[action + 'EventListener']('noteRemoved', dropNote);
				writerModel[action + 'EventListener']('noteToggleFoldRequested', foldNote);
				writerModel[action + 'EventListener']('noteEditRequested', startEditing);
				writerModel[action + 'EventListener']('noteChanged noteAdded', changeNote);
			};


		listeners('add');
		title.text(note.title).on('click', function (e) {
			if (timeoutId) {
				window.clearTimeout(timeoutId);
				timeoutId = false;
			}
			timeoutId = window.setTimeout(function () {

				if (!viewer.attr('contenteditable')) {
					writerModel.setActiveNodeId(note.nodeId);
				}
			}, 250);
			e.preventDefault();
			e.stopImmediatePropagation();
		}).on('dblclick', function (e) {
			if (timeoutId) {
				window.clearTimeout(timeoutId);
				timeoutId = false;
			}
			element.toggleClass('folded');
			e.preventDefault();
			e.stopImmediatePropagation();
		});

		viewer.html(note.text ? noteFormatter(note.text) : '').on('click', function (evt) {
			if (!evt.currentTarget.hasAttribute('contenteditable')) {
				writerModel.editNoteForNodeId(note.nodeId);
			}
		});
		viewer.on('blur', exitAndSave);
		viewer.on('keydown', function (e) {
			if (e.which === KEY_ESC) {
				shouldSave = false;
				exitEditor(true);
			}
		});
		element.on('contextmenu', function (event) {
			if (!viewer.attr('contenteditable') && writerModel.requestContextMenu(event.pageX, event.pageY)) {
				writerModel.setActiveNodeId(note.nodeId);
				event.preventDefault();
				return false;
			}
		});
		if (shouldEdit) {
			startEditing(initialNote);
		}
	});
};


